import { deburr } from 'lodash';

export const FILE_NAME_TOKENS = ['date', 'artist', 'venue', 'city'];

export const TOKEN_LABELS = {
  date: 'Date',
  artist: 'Artist',
  venue: 'Venue',
  city: 'City',
};

const PLACEHOLDER_VALUES = {
  artist: 'Artist Name',
  venue: 'Venue Name',
  city: 'City',
};

const SAMPLE_DATE = '2024-03-18';
const NO_DATE_LABEL = 'MAD';

export const parseTemplate = (value) => {
  if (!value) return [];
  const seen = new Set();
  return value
    .split(',')
    .map((key) => key.trim().toLowerCase())
    .filter((key) => FILE_NAME_TOKENS.includes(key))
    .filter((key) => {
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export const serializeTemplate = (tokens) => tokens.join(',');

// deburr mirrors Rails parameterize, which transliterates accents via I18n.transliterate.
export const parameterize = (str) =>
  deburr(String(str))
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const previewFileName = (tokens, { withDate, artist, venue, city } = {}) => {
  const order = tokens.length === 0 ? FILE_NAME_TOKENS : tokens;

  const values = {
    artist: artist || PLACEHOLDER_VALUES.artist,
    venue: venue || PLACEHOLDER_VALUES.venue,
    city: city || PLACEHOLDER_VALUES.city,
    date: withDate ? SAMPLE_DATE : NO_DATE_LABEL,
  };

  return order
    .map((token) => values[token])
    .filter(Boolean)
    .map(parameterize)
    .map((segment) => segment.toUpperCase())
    .join('-');
};
